/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Section_BodyInputs */

const en_us2_profile_section_body = /** @type {(inputs: Profile_Section_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body`)
};

const pt_br2_profile_section_body = /** @type {(inputs: Profile_Section_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo`)
};

const es_419_profile_section_body = /** @type {(inputs: Profile_Section_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuerpo`)
};

const pt_pt2_profile_section_body = /** @type {(inputs: Profile_Section_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo`)
};

const fr_fr2_profile_section_body = /** @type {(inputs: Profile_Section_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corps`)
};

const de_de2_profile_section_body = /** @type {(inputs: Profile_Section_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körper`)
};

const it_it2_profile_section_body = /** @type {(inputs: Profile_Section_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corpo`)
};

/**
* | output |
* | --- |
* | "Body" |
*
* @param {Profile_Section_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_section_body = /** @type {((inputs?: Profile_Section_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Section_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_section_body(inputs)
	if (locale === "es-419") return es_419_profile_section_body(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_section_body(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_section_body(inputs)
	if (locale === "de-DE") return de_de2_profile_section_body(inputs)
	if (locale === "it-IT") return it_it2_profile_section_body(inputs)
	return en_us2_profile_section_body(inputs)
});
export { profile_section_body as "profile.section_body" }